import { makeAutoObservable } from 'mobx';

// 新开本地智能体对话时储存 agent_id
class AgentStore {
  constructor() {
    makeAutoObservable(this);
  }

  agent_id = null;

  setAgentId = (id) => {
    this.agent_id = id;
  }
 
}

const agentStore = new AgentStore();

export default agentStore